<nb-card>
  <nb-card-header>Last 6 months notice</nb-card-header>
  <nb-card-body>
    <p class="confirm-text">
      There was {{ data?.eventTypeName }} in the last 6 months.<br />
      Please acknowledge to continue.
    </p>
  </nb-card-body>
  <nb-card-footer>
    <div class="buttons-container">
      <button class="btn btn-primary" (click)="close()">I understand</button>
    </div>
  </nb-card-footer>
</nb-card>
